import { render, staticRenderFns } from "./NewBonusesComponent.vue?vue&type=template&id=6ba0f400"
import script from "./NewBonusesComponent.vue?vue&type=script&lang=js"
export * from "./NewBonusesComponent.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./NewBonusesComponent.vue?vue&type=style&index=1&id=6ba0f400&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports